import FlexColumn from "designSystem/components/flex/FlexColumn";
import PaneHeader from "designSystem/components/pane/PaneHeader";
import { useStore } from "csi/state/hooks";
import React from "react";
import ConnectToMSTeamsFirstTime from "./ConnectToMSTeamsFirstTime";
import ConnectToMSTeamsNextTime from "./ConnectToMSTeamsNextTime";
import { useMSTeamsStore } from "./MSTeamsStore";

const ConnectToMSTeams: React.FunctionComponent = () => {
	const { closeRightPane } = useMSTeamsStore();
	const { routerStore } = useStore();
	const node = routerStore.locationNode;
	const nodeMSTeamsChannels = node.MSTeamsChannels;

	const CurrentComponent = () => (0 === nodeMSTeamsChannels.length)
		? <ConnectToMSTeamsFirstTime />
		: <ConnectToMSTeamsNextTime />;

	return (
		<FlexColumn>
			<PaneHeader
				back={false}
				onClose={closeRightPane}
				titleRes="MSTeams"
			/>
			<CurrentComponent />
		</FlexColumn>
	);
};

export default ConnectToMSTeams;